import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAbility } from '@casl/react';
import { Button, Col, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { Icon } from '../..';
import { useSetTab } from '../../../services/hooks';
import { AbilityContext } from '../../../config/abilityContext';
import MyProfileDashboardIndex from '../../../screens/Profile/Dashboard/MyProfileDashboardIndex';
import TeamDashboardIndex from '../../../screens/Profile/Dashboard/TeamDashboardIndex';
import Supervisor from './Supervisor/index';

import { getMeRequest } from '../../../requests/auth';
import { camelCaseEmptyStringRecursive } from '../../../services/utils';
import { validateToken } from '../../../actions/auth';

const basicUser = {
  avatar: [],
  email: '',
  id: '',
  name: '',
  first_name: '',
  nationalIdentification: '',
  role: '',
  employeeCard: {
    fileInfo: {}
  }
};

const Greeting = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [key, setKey] = useSetTab('profile', location, 'board');
  const ability = useAbility(AbilityContext);
  const hasTeam = ability.can('boss', 'Employee');
  const hasSupervisor = ability.can('supervisor_workers', 'Employee');
  const [user, setUser] = useState(basicUser);
  const [showSpinner, setShowSpinner] = useState(1);
  const { currentCompany } = useSelector(state => state.auth);
  const employeeName = user.name.trim().split(' ')[0];
  const companyName = currentCompany.businessName;

  const dispatchGetMe = () => {
    getMeRequest({
      dispatch,
      successCallback: response => {
        if (response.data.logged_in) {
          setUser(camelCaseEmptyStringRecursive(response.data.user_info));
          setShowSpinner(0);
        } else {
          dispatch(validateToken());
        }
      }
    });
  };
  useEffect(dispatchGetMe, []);

  const tabText = keyTab => {
    const textsTab = [
      { key: 'profile', label: 'Trabajador' },
      { key: 'team', label: 'Jefatura' },
      { key: 'supervisor', label: 'Supervisor' }
    ];
    return textsTab.find(t => t.key === keyTab)?.label ?? '';
  };

  return (
    <>
      <div className="MainDivCard" style={{ backgroundColor: '#f5f5f5' }}>
        <div className="col-sm-12">
          <Row>
            <Col md={6} xl={6} xs={12} className="mt-1">
              <p style={{ fontSize: '20px', fontWeight: 'bold' }}>
                <span style={{ color: '#2bb48f' }}>Dashboard</span> {`${tabText(key)}`}
              </p>
            </Col>
            <Col md={6} xl={6} xs={12}>
              <Row className="mt-2">
                {(hasTeam || hasSupervisor) && (
                  <Col sm={4} md={4}>
                    <Button
                      variant={`${key === 'profile' ? 'primary' : 'outline-primary'}`}
                      className={`toogle ${key === 'profile' ? 'active' : ''} mb-1`}
                      block
                      onClick={() => setKey('profile')}
                      size="sm"
                      style={{ color: `${key === 'profile' ? '#fff' : '#000'}` }}
                    >
                      <Icon className="icon-15" icon="person" /> Trabajador
                    </Button>
                  </Col>
                )}
                {hasTeam && (
                  <Col sm={4} md={4} className="ml-0">
                    <Button
                      variant={`${key === 'team' ? 'primary' : 'outline-primary'}`}
                      className={`toogle ${key === 'team' ? 'active' : ''} mb-1`}
                      block
                      onClick={() => setKey('team')}
                      size="sm"
                      style={{ color: `${key === 'team' ? '#fff' : '#000'}` }}
                    >
                      <Icon className="icon-15" icon="people" /> Jefatura
                    </Button>
                  </Col>
                )}
                {hasSupervisor && (
                  <Col sm={4} md={4} className="ml-0">
                    <Button
                      variant={`${key === 'supervisor' ? 'primary' : 'outline-primary'}`}
                      className={`toogle ${key === 'supervisor' ? 'active' : ''} mb-1`}
                      block
                      onClick={() => setKey('supervisor')}
                      size="sm"
                      style={{ color: `${key === 'supervisor' ? '#fff' : '#000'}` }}
                    >
                      <Icon className="icon-15" icon="people" /> Supervisor
                    </Button>
                  </Col>
                )}
              </Row>
            </Col>
          </Row>
        </div>
        <div className="col-sm-12 MainDivHrCard mb-4 h-100">
          {key === 'profile' && (
            <MyProfileDashboardIndex
              companyName={companyName}
              currentTab={key}
              employeeName={employeeName}
              user={user}
              showSpinner={showSpinner}
            />
          )}
          {hasTeam && key === 'team' && (
            <TeamDashboardIndex companyName={companyName} currentTab={key} employeeName={employeeName} user={user} />
          )}
          {hasSupervisor && key === 'supervisor' && (
            <Supervisor companyName={companyName} employeeName={employeeName} />
          )}
        </div>
      </div>
    </>
  );
};

export default Greeting;
